import React from "react";

import { Routes, Route, Navigate } from "react-router-dom";

import PATH from "../../constants/routes";
import Homepage from "./../../pages/Homepage/Homepage";
import SearchPage from "../../pages/Search/SearchPage";
import NotFound from "./../../pages/NotFound/NotFound";
import LoginRoutes from "../PublicRoutes/LoginRoutes";
import PrivateRoute from "../PrivateRoutes/PrivateRoutes";
import VideosRoutes from "../PrivateRoutes/VideosRoutes";
import QbankRoutes from "../PrivateRoutes/QbankRoutes";
import TestsQuizRoutes from "../PrivateRoutes/TestQuizRoutes";
import SignupRoutes from "../PublicRoutes/SignupRoutes";

export default function BaseRoutes() {
  return (
    <Routes>
      {/* public routes */}
      <Route path={PATH.LOGIN + "/*"} element={<LoginRoutes />} />
      <Route path={PATH.SIGNUP + "/*"} element={<SignupRoutes />} />

      {/* private routes */}
      <Route element={<PrivateRoute />}>
        <Route path={PATH.HOMEPAGE} element={<Homepage />} />
        <Route path={PATH.SEARCH} element={<SearchPage />} />
        <Route path={PATH.VIDEOS + "/*"} element={<VideosRoutes />} />
        <Route path={PATH.QBANK + "/*"} element={<QbankRoutes />} />
        <Route path={PATH.TESTS + "/*"} element={<TestsQuizRoutes />} />
      </Route>

      {/* fallback route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
